import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  FinanceWidgetEnvelope,
  FinanceWidgetsRequest,
} from 'src/models/monthly-finance.model';

@Injectable({ providedIn: 'root' })
export class DashboardWidgetsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.api_url;

  fetchWidgets(widgets: FinanceWidgetsRequest): Observable<FinanceWidgetEnvelope[]> {
    const url = `${this.baseUrl}api/v1/customer/dashboard/widgets/fetch`;
    return this.http.post<FinanceWidgetEnvelope[]>(url, { widgets });
  }
}
